// extracted by mini-css-extract-plugin
module.exports = {"section":"Login_section__3Zq_w"};